import React, { useState, useMemo, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import PdfModal from 'components/Tvendo/Common/PdfModal';
import Button from 'components/CustomButtons/Button.js';
import ShowDocument from './Common/Body/ShowDocuments';
import ShowChecks from './Common/Body/ShowChecks';
import { PictureAsPdf } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { WithApp } from 'contexts/appContext';
import { wsGet } from 'services/WService';
import { useParams } from 'react-router';
import moment from 'moment';

function ShowPayment(props) {
  const paymentId = useParams().id;
  const { paymentType } = props;

  const [pdfId, setPdfId] = useState();
  const [payment, setPayment] = useState({});
  const [details, setDetails] = useState([]);
  const [checks, setChecks] = useState([]);
  const [accounts, setAccounts] = useState([]);

  const [title, DocTypeDescription, paymentMethod] = useMemo(() => {
    if (payment.id === undefined) return ['', '', ''];
    let DocTypeDescription = '';
    switch (payment.DocType) {
      case 'S':
        DocTypeDescription = 'Proveedor';
        break;
      case 'C':
        DocTypeDescription = 'Cliente';
        break;
      case 'A':
        DocTypeDescription = 'Cuenta';
        break;
    }
    let paymentMethod = '';
    switch (payment.type) {
      case 'CH':
        paymentMethod = 'Efectivo';
        break;
      case 'CR':
        paymentMethod = 'Crédito';
        break;
      case 'CK':
        paymentMethod = 'Cheque';
        break;
      case 'LT':
        paymentMethod = 'Letra';
        break;
      case 'TR':
        paymentMethod = 'Transferencia';
        break;
      case 'MT':
        paymentMethod = 'Múltiple';
        break;
    }

    let title =
      paymentType === 'ACCOMPLISHED' ? `Pago efectuado ${paymentId}` : `Pago recibido ${paymentId}`;

    return [title, DocTypeDescription, paymentMethod];
  }, [payment]);

  // Si es Proveedor o cliente
  // Sabes si se pago con documentos
  const payWithDocuments = useMemo(() => {
    return details.length > 0;
  }, [details]);

  async function getPayment() {
    let entity = 'pymt/received-payment';
    if (paymentType === 'ACCOMPLISHED') {
      entity = 'pymt/accomplished-payment';
    }
    let res = await wsGet(entity, paymentId);
    if (res.success === false) {
      alert(`Error: ${res.message}`);
      return;
    }
    let { details, checks, accounts, ...payment } = res.data;
    setPayment(payment);
    setDetails(details);
    setAccounts(accounts);
    setChecks(checks);
  }

  function openPdfModal(id) {
    setPdfId(id);
  }

  const pdfSrc = useMemo(() => {
    if (pdfId === undefined) return;
    let entity =
      paymentType === 'ACCOMPLISHED' ? `pymt/accomplished-payment` : `pymt/received-payment`;
    return `${entity}/${pdfId}/pdf`;
  }, [pdfId]);

  useEffect(() => {
    getPayment();
  }, []);

  if (payment.id === undefined) {
    return <CardContainer title="Cargando..." />;
  }

  return (
    <>
      <PdfModal open={pdfId !== undefined} onClose={() => setPdfId(undefined)} src={pdfSrc} />

      <CardContainer
        title={`${title}${payWithDocuments === false ? ' Entrega a rendir cuenta' : ''}`}
      >
        <GridContainer>
          <GridItem xs={6}>
            <h6>Pago tipo:</h6>
            <h5>{DocTypeDescription}</h5>
          </GridItem>

          {/* Socio en pagos tipo Proveedor/Cliente */}
          {['S', 'C'].includes(payment.DocType) && (
            <GridItem xs={6}>
              <h6>Socio: </h6>
              <h5>
                {payment.CardCode} - {payment.CardName}
              </h5>
            </GridItem>
          )}

          {/* Pagar / En favor de para pagos tipo Cuenta */}
          {payment.DocType === 'A' && (
            <>
              <GridItem xs={6}>
                <h6>Pagar a:</h6>
                <h5>{payment.CardName}</h5>
              </GridItem>

              <GridItem xs={6}>
                <h6>En favor de:</h6>
                <h5>{payment.Address}</h5>
              </GridItem>
            </>
          )}

          <GridItem xs={6}>
            <h6>Zona:</h6>
            <h5>{payment.zone.description}</h5>
          </GridItem>

          <GridItem xs={6}>
            <h6>Total:</h6>
            <h5>{parseFloat(payment.TotalSum).toFixed(2)}</h5>
          </GridItem>

          <GridItem xs={6}>
            <h6>Médoto de pago:</h6>
            <h5>{paymentMethod}</h5>
          </GridItem>

          <GridItem xs={6}>
            <Button justIcon round simple color="info" onClick={() => openPdfModal(payment.id)}>
              <PictureAsPdf />
            </Button>
          </GridItem>
        </GridContainer>
      </CardContainer>

      {/* Proveedor / Cliente */}
      {['S', 'C'].includes(payment.DocType) && payWithDocuments && (
        <CardContainer title={'Documentos'} icon={null} style={{ height: '400px' }}>
          <ShowDocument documents={details} />
        </CardContainer>
      )}

      {/* Cuenta */}
      {payment.DocType === 'A' && (
        <CardContainer title={'Cuentas'} icon={null}>
          <ul>
            {accounts.map((account, index) => {
              return (
                <li key={index}>
                  {`(${account.AcctCode}) ${account.AcctName} S/${account.SumApplied}`}
                </li>
              );
            })}
          </ul>
        </CardContainer>
      )}

      <CardContainer title={'Método de pago ' + paymentMethod} icon={null}>
        <GridContainer>
          <GridItem xs={6} md={4}>
            <h6>Fecha creación</h6>
            <h5>{moment(payment.created_at).format('DD/MM/YYYY')}</h5>
          </GridItem>
          <GridItem xs={6} md={4}>
            <h6>Fecha contable</h6>
            <h5>{moment(payment.DocDate).format('DD/MM/YYYY')}</h5>
          </GridItem>
          <GridItem xs={6}>
            <h6>Comentario</h6>
            <h5>{payment.Comments}</h5>
          </GridItem>
        </GridContainer>

        {['TR', 'CK'].includes(payment.type) && (
          <GridContainer>
            {payment.type === 'TR' && (
              <>
                <GridItem xs={6} md={4}>
                  <h6>Cuenta de mayor</h6>
                  <h5>{payment.TrsfrAcct}</h5>
                </GridItem>
                <GridItem xs={6} md={4}>
                  <h6>Fecha de transferencia</h6>
                  <h5>{payment.TrsfrDate}</h5>
                </GridItem>
                <GridItem xs={6} md={4}>
                  <h6>Referencia</h6>
                  <h5>{payment.TrsfrRef}</h5>
                </GridItem>
              </>
            )}

            {payment.type === 'CK' && (
              <GridItem xs={12} style={{ height: '300px' }}>
                <ShowChecks checks={checks} />
              </GridItem>
            )}
          </GridContainer>
        )}
      </CardContainer>
    </>
  );
}

export default WithApp(ShowPayment);
